import { RugbyUnionIncidentId } from '@collector/sportsapi-client-legacy'

import { AddIncidentConfig } from '../../../configuration'

export const addIncidentConfig: AddIncidentConfig<RugbyUnionIncidentId> = {
  scoreIncidents: [
    RugbyUnionIncidentId.Try,
    RugbyUnionIncidentId.DropGoal,
    RugbyUnionIncidentId.PenaltyTry,
    RugbyUnionIncidentId.PenaltyKickGoal,
    RugbyUnionIncidentId.ConversionGoal,
  ],
  missedIncidents: [
    RugbyUnionIncidentId.DropGoalMissed,
    RugbyUnionIncidentId.PenaltyKickMissed,
    RugbyUnionIncidentId.ConversionMissed,
  ],
}
